import { useState } from "react";
import { Modal, Form, Select, InputNumber, message, Spin } from "antd";
import { createListFundsPortfolio, checkExistFundsPortfolio } from "../../../../services";
import { all_stocks_data } from "../../../../utils/data";
import { portfolio_urls } from "../../../../utils/portfolio-urls";
import AntTable from "../../../../components/common/AntTable";
import ExcelFromUrlPreview from "../../../../components/common/ExcelFromUrlPreview";
const mockUrlData = 'https://dragoncapitalprod.blob.core.windows.net/cms1public/DCDE_BC_THANG_04_2025.xlsx';

const PortfoliosCawler = ({ isOpenModal, onClose }) => {
  const fundsData = portfolio_urls.filter(e => e.status);
  const [selectedUrl, setSelectedUrl] = useState(mockUrlData);
  const [selectedUrlEx, setSelectedUrlEx] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [currentData, setCurrentData] = useState([]);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const [submiting, setSubmiting] = useState(false);

  const width = "90%";

  const initialValues = {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  };

  const handleCloseModal = (isReload) => {
    setData([]);
    onClose(isReload);
  };

  const onSubmit = () => {
    if (currentData.length > 0) {
      message.warning("Dữ liệu đã tồn tại, vui lòng kiểm tra lại!");
      return;
    }

    if (data.length === 0) return;

    setSubmiting(true);

    form
      .validateFields()
      .then(async (values) => {
        const fundData = fundsData.find((e) => e.fund_code === values.fund);
        const convertedData = data.map((e) => {
          return {
            stock_code: e.stock_code.trim(),
            quantity: e.quantity,
            market_price: e.market_price,
            value: e.value,
            portfolio_rate: e.portfolio_rate,
            year: values.year,
            month: values.month,
            fund_code: fundData.fund_code.trim(),
            period: `${values.month}/${values.year}`,
          };
        });

        try {
          await createListFundsPortfolio(convertedData);

          message.success("Thêm dữ liệu thành công!");
          setData([]);
          setCurrentData([]);
          onCheckExistData();
        } catch (error) {
          message.error("Thêm dữ liệu thất bại!");
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      })
      .finally(() => {
        setSubmiting(false);
      });
  };

  const onSubmitFromCrawler = (dataImport) => {
    if (currentData.length > 0) {
      message.warning("Dữ liệu đã tồn tại, vui lòng kiểm tra lại!");
      return;
    }

    if (dataImport.length === 0) return;

    setSubmiting(true);
    form
      .validateFields()
      .then(async (values) => {
        const fundData = fundsData.find((e) => e.fund_code === values.fund);
        const convertedData = dataImport.map((e) => {
          return {
            stock_code: e.stock_code.trim(),
            quantity: e.quantity,
            market_price: e.market_price,
            value: e.value,
            portfolio_rate: e.portfolio_rate,
            year: values.year,
            month: values.month,
            fund_code: fundData.fund_code.trim(),
            period: `${values.month}/${values.year}`,
          };
        });

        try {
          await createListFundsPortfolio(convertedData);

          message.success("Thêm dữ liệu thành công!");
          setData([]);
          setCurrentData([]);
          onCheckExistData();
        } catch (error) {
          message.error("Thêm dữ liệu thất bại!");
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      })
      .finally(() => {
        setSubmiting(false);
      });
  };

  const onCheckExistData = async () => {
    try {
      const fundCode = form.getFieldValue("fund");
      const year = form.getFieldValue("year");
      const month = form.getFieldValue("month");

      if (!fundCode || !year || !month) return;
      const period = `${month}/${year}`;

      setSubmiting(true);
      const res = await checkExistFundsPortfolio(period, fundCode);

      if (res.data.length === 0) {
        setCurrentData([]);
        return;
      }

      const converedData = res.data.map((e, index) => {
        const stock = all_stocks_data.find((s) => s.Symbol === e.stock_code);

        return {
          ...e,
          key: index.toString(),
          index: index + 1,
          fund_code: e.fund_code,
          company_name: stock.CompanyName,
          category: stock.CategoryName,
        };
      });
      setCurrentData(converedData);
    } catch (error) {
      message.error(error.message);
    } finally {
      setSubmiting(false);
    }
  };

  const onFormChange = () => {
    onCheckExistData();
    const fundData = portfolio_urls.find(e => e.fund_code === form.getFieldValue("fund"));
    
    if (!form.getFieldValue("fund")) return;

    const monthDataForm =  form.getFieldValue("month")
    const yearDataForm =  form.getFieldValue("year")

    let tempUrl = fundData.url_data;
    setSelectedUrlEx(fundData.url_data_ex);

    if (tempUrl.includes('MM_BC')) {
      if (monthDataForm < 10) {
        tempUrl = tempUrl.replace('MM_BC', `0${monthDataForm}`)
      } else {
        tempUrl = tempUrl.replace('MM_BC', monthDataForm)
      }
    } else if (tempUrl.includes('M_BC')) {
      tempUrl = tempUrl.replace('M_BC', monthDataForm - 1)
    }

    if (tempUrl.includes('YYYY_BC')) {
      tempUrl = tempUrl.replace('YYYY_BC', yearDataForm)
    }

    if (tempUrl.includes('YYYY_UP')) {
      tempUrl = tempUrl.replace('YYYY_UP', yearDataForm)
    }

    if (tempUrl.includes('MM_UP')) {
      const currentMonth = new Date().getMonth() + 1;
      if (currentMonth < 10) {
        tempUrl = tempUrl.replace('MM_UP', `0${currentMonth}`)
      } else {
        tempUrl = tempUrl.replace('MM_UP', currentMonth)
      }
    }

    if (tempUrl.includes('YYYYMMDD_UP')) {
      const today = new Date();
      let currentYear = today.getFullYear();
      let currentMonth = today.getMonth() + 1;
      let currentDate = today.getDate();

      if (currentMonth < 10) {
        currentMonth = '0' + currentMonth;
      } 

      if (currentDate < 10) {
        currentDate = '0' + currentDate;
      } 

      tempUrl = tempUrl.replace('YYYYMMDD_UP', `${currentYear}${currentMonth}${currentDate}`);
    }

    setSelectedUrl(tempUrl)
  }

  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <Modal
      title={<h3>Thêm mới danh mục đầu tư</h3>}
      centered
      open={isOpenModal}
      onOk={onSubmit}
      onCancel={() => handleCloseModal(false)}
      width={width}>
      <Form form={form} layout="inline" initialValues={initialValues}>
        <Form.Item
          label="Quỹ đầu tư"
          name="fund"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn quỹ!",
            },
          ]}>
          <Select
            showSearch
            placeholder="Chọn quỹ đầu tư"
            filterOption={filterOption}
            onChange={onFormChange}
            options={fundsData}
            style={{ width: 250 }}
          />
        </Form.Item>
        <Form.Item
          name="year"
          label="Kỳ thống kê"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn năm!",
            },
          ]}>
          <InputNumber placeholder="Năm" onChange={onFormChange} />
        </Form.Item>
        <Form.Item
          name="month"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn tháng!",
            },
          ]}>
          <InputNumber placeholder="Tháng" onChange={onFormChange} />
        </Form.Item>
      </Form>

      {currentData.length > 0 && (
        <Spin spinning={submiting}>
          <h1 className="text-xl my-2" style={{ color: "red"}}>
            Danh mục đã tồn tại Quỹ {form.getFieldValue("fund")} Kỳ {form.getFieldValue("month")}/
            {form.getFieldValue("year")}
          </h1>
        </Spin>
      )}

      {currentData.length === 0 && (
        <Spin spinning={submiting}>
          <h1 className="text-xl my-2" style={{ color: "orange" }}>
            Quỹ {form.getFieldValue("fund")} Kỳ {form.getFieldValue("month")}/
            {form.getFieldValue("year")} chưa có dữ liệu
          </h1>
        </Spin>
      )}

      <div className="flex items-center gap-4 my-2 w-full">
        <label className="font-semibold">📝 Urls:</label>
        <input
          type="text"
          name="title"
          value={selectedUrl}
          onChange={(e) => setSelectedUrl(e.target.value)}
          placeholder="Nhập urls để lấy dữ liệu"
          className="mt-2 text-lg flex-1 p-3 rounded-xl border border-gray-300"
          required
        />

        <button
          onClick={() => setPreviewUrl(selectedUrl)}
          disabled={!selectedUrl}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg disabled:opacity-50"
        >
          Fetch data from url
        </button>
      </div>

      {selectedUrlEx &&<div className="flex items-center gap-4 my-2">
        <label className="font-semibold">📝 Ex:</label>
        <span>{selectedUrlEx}</span>
      </div>}

      {data.length > 0 && (
        <Spin spinning={submiting}>
          <h4>Danh sách danh mục preview</h4>
          <AntTable data={data} />
        </Spin>
      )}

      <hr className="my-4"></hr>
      <h1 className="text-center font-bold text-2xl my-4">
        Báo cáo Quỹ {form.getFieldValue("fund")} Kỳ {form.getFieldValue("month")}/
        {form.getFieldValue("year")}
      </h1>
      
      {previewUrl && <ExcelFromUrlPreview fileUrl={previewUrl} onSubmit={onSubmitFromCrawler}/>}
    </Modal>
  );
};
export default PortfoliosCawler;
